import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

function comparator (a, b) {
  if (a.nombre > b.nombre) return -1
  if (a.nombre < b.nombre) return 1
  return 0
}

export const fetchCerealesVariedades = async (cereal) => lrsAdapter(await getAxiosInstance().get(`/cereal_variedad?r={"clave":{"cereal":"${cereal}"},"orden":["d:nombre_corto_variedad"]}`)).data.sort(comparator)

class CerealVariedad {
  static getVariedades (cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_variedad?r=` +
      `{"clave":{"cereal":"${cereal}"},"orden":["nombre"]}`)
    return promise.then(lrsAdapter)
      .then((result) => { return result.data })
      // .then(response => response.data.sort(comparator))
  }

  static getVariedad (cereal, nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cereal_variedad_completo?r=` +
      `{"clave":{"cereal_especie":"${cereal}", "nombre_corto_variedad":"${nombre.toUpperCase()}"},"limite":1}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }
}

export default CerealVariedad
